// For env variables that have multiple options we can set up getters here
// the goal of this file is to not raw dog environmental variables in the code
// as much as possible.
export const areExperimentalFeaturesEnabled = () => process.env.EXPERIMENTAL_UI_FEATURES === 'true';
export const getAmplitudeApiKey = () => process.env.AMPLITUDE_API_KEY || '';
export const isAmplitudeGuidesAndSurveysEnabled = () => process.env.AMPLITUDE_GUIDES_AND_SURVEYS === 'true';
export const getAppVersion = () => process.env.APP_VERSION;
